import axios from "axios";

let http = (url, param) => {
    return $http(url, param);
};
let httpfile=(url, param) => {
    return $httpfile(url, param);
};
let httptxt=(url, param) => {
    return $httptxt(url, param);
};
let httpform=(url, param) => {
    return $httpform(url, param);
};
function $http(url, param) {
	//console.log('url:'+url,param);
	//debugger
	if(param.timeout!=undefined){
		return axios({
		    method: "post",
		    url: url,
		    data: param.data,
			timeout:param.timeout
		});
	}else{
		return axios({
		    method: "post",
		    url: url,
		    data: param.data
		});
	}
}
function $httptxt(url, param) {
    if (param.methods == "POST" || param.methods == "post") {
        return axios.post(url, param.data);
    }
    return axios({
        method: param.methods || "get",
        url: url,
        data: param.data,
		headers: { 'content-type': 'application/x-www-form-urlencoded' }
    });
    // axios.get(url, {
    //     params: param.data
    // });
}
function $httpfile(url, param) {
	if (param.methods == "POST" || param.methods == "post") {
		if(param.timeout!=undefined)
			return axios.post(url, param.data,{timeout:param.timeout});
		else 
			return axios.post(url, param.data);
	}
	return axios({
		method:"post",
		url: url,
		data: param.data,
		responseType: 'blob'
	});
}
function $httpform(url, param) {
	//console.log('url:'+url,param);
	//debugger
	let formData = new FormData();
	    //参数
		for(var s in param.data)
		{
			formData.append(s.toString(),param.data[s]);
		}
	if(param.timeout!=undefined){
		return axios({
		    method: "post",
		    url: url,
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
		    data: formData,
			timeout:param.timeout
		});
	}else{
		return axios({
		    method: "post",
		    url: url,
			headers: { 'content-type': 'multipart/form-data' },
		    data: formData
		});
	}
}

export default {
	http,
	httpfile,
	httptxt,
	httpform
};